import $ from "jquery";
import {GPMisc} from "../gp-misc";
import GPLogin from "../gp-login.svelte";
import jQuery from "jquery";

export let GPStorageFMG = {
    token: null,
    onlineAppEmail: null,

    saveOnlineProject: function(params) {
        params['email'] = GPStorageFMG.onlineAppEmail;
        params['token'] = GPStorageFMG.token;
        return new Promise((resolve, reject) => {
            $.ajax({
                dataType: "json",
                data: params,
                type: "POST",
                url: GPSettings.servicesAddr+"/saveProject",
                success: (res) => {
                    if (res.result === "error")
                        reject();
                    else {
                        res.savedId = res.projectId;
                        res.title = params.title;
                        resolve(res);
                    }
                },
                error: reject
              });

        })
    },

    saveToFile: function(data) {
        return new Promise((resolve => {
            let blob = new Blob([data], {type: "application/json"});
            let url  = URL.createObjectURL(blob);

            $('body').append("<a target='_blank' id='downloadlink' download='project.prj' style='display: none'></a>");
            let link = $('#downloadlink');
            link.attr('href', url);
            setTimeout(function() {
                link[0].click();
                link.remove();
                resolve({path:null, title:null});
            }, 100);
        }))
    },

    loadOnlineProjectDetails: function(projId) {
        let params = "?id=" + projId + "&email=" + encodeURIComponent(GPStorageFMG.onlineAppEmail) + "&token=" + encodeURIComponent(GPStorageFMG.token);
        return fetch(GPSettings.servicesAddr+"/getProjectDetails"+params).then(res => res.json()).then(res => {res.savedId = projId; return res})
    },

    /**
     *
     * @param {File} file
     * @return {Promise<String>}
     */
    loadProjectFromFile: function(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (e) {
                let prj = JSON.parse(reader.result);
                resolve(prj);
            };
            reader.readAsText(file);
        })
    },

    getUsersOnlineProjects: function() {
        var params = {};
        params['token'] = GPStorageFMG.token;
        params['email'] = GPStorageFMG.onlineAppEmail;

        return new Promise((resolve, reject) => {
            $.ajax({
                dataType: "json",
                data: params,
                url: GPSettings.servicesAddr + "/getProjects",
                success: resolve,
                error: reject
            })
        });
    },

    /**
     *
     * @return {Promise<File>}
     */
   selectFileForOpening: function() {
       return GPMisc.askForFile('.prj')
   },
   
    deleteOnlineProject: function(projId) {
        var params = {};
        params['token'] = GPStorageFMG.token;
        params['email'] = GPStorageFMG.onlineAppEmail;
        params['id'] = projId;

        return new Promise((resolve, reject) => {
            $.ajax({
                dataType: "json",
                data: params,
                url: GPSettings.servicesAddr + "/removeProject",
                success: resolve,
                error: reject
            })
        });
    },

    exportJPG: function(jpg) {
        var pageImage = new Image();
        pageImage.src = jpg;
        pageImage.onload = function() {
            var canvas = document.createElement('canvas');
            canvas.width = pageImage.naturalWidth;
            canvas.height= pageImage.naturalHeight;

            var ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = false;
            ctx.drawImage(pageImage, 0, 0);
            saveScreenshot(canvas);
        };
        function saveScreenshot(canvas) {
            var link = document.createElement('a');
            link.download = 'image.jpg';
            canvas.toBlob(function(blob) {
                link.href = URL.createObjectURL(blob);
                link.click();
            }, 'image/jpeg', 0.7);
        }
    },

    shareByEmail: function(email, message, projectid) {
        let formData = new FormData();
        formData.append('receipientEmail', email);
        formData.append('message', message);
        formData.append('projectid', projectid);
        formData.append('email', GPStorageFMG.onlineAppEmail);
        formData.append('token', GPStorageFMG.token);

        return fetch(GPSettings.servicesAddr + '/sendByEmail', {
            method: 'POST',
            body: formData
        }).then(response => response.json())
    },

    callbackPreloaderSetProgress: function (progress) {
        return GP.preloaderSetProgress(progress);
    },
    
    callbackInitApp: function (prodList) {
        if (prodList && prodList.length)
            GP.setProducts(prodList);
        return GP.initApp();
    },
    
    getCustomBackgroundImage: function() {
        return GPMisc.askForFile('image/jpeg,image/heic,image/webp').then(GPMisc.loadImageFile);
    },
    

    uploadCustomObject: function(res, name) {
        return new Promise((resolve, reject) => {
            var img = res.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
            var params = {
                image : img,
                email: GPStorageFMG.onlineAppEmail,
                token: GPStorageFMG.token,
                name: name
            };
            $.ajax({
                dataType: "json",
                data: params,
                type: "POST",
                url: GPSettings.servicesAddr+"/uploadCustomObject",
                success: (res) => {
                    if (res.result === "error")
                        reject();
                    else {
                        GPStorageFMG.loadCustomObjects();
                        resolve(res)
                    }
                },
                error: reject
              });

        });
    },
        
    storeKey: function(key, data) {
        localStorage[key] = data;
    },
    
    restoreKey: function(key) {
        return localStorage[key];
    },
    
    loadCustomObjects: function() {
        var params = {};
        params['token'] = GPStorageFMG.token;
        params['email'] = GPStorageFMG.onlineAppEmail;
        $.ajax({
            dataType: "json",
            data: params,
            url: GPSettings.servicesAddr+"/getCustomObjects",
            success: GP.processCustomObjects
          });
    },
    
    deleteCustomObject: function(itemId) {
        return new Promise((resolve, reject) => {
            var params = {
                id : itemId,
                email: GPStorageFMG.onlineAppEmail,
                token: GPStorageFMG.token
            };
            $.ajax({
                dataType: "json",
                data: params,
                type: "POST",
                url: GPSettings.servicesAddr+"/deleteCustomObject",
                success: (res) => {if (res.result==="error") reject(); else GPStorageFMG.loadCustomObjects(); resolve() },
                error: reject
              });

        })
    },

    uploadSnippet: function(params, thumb) {
        return new Promise((resolve, reject) => {
            params['img'] = thumb.replace(/^data:image\/(png|jpg|jpeg|webp);base64,/, "");
            params['email'] = GPStorageFMG.onlineAppEmail;
            params['token'] = GPStorageFMG.token;
            params['private'] = 1;
            $.ajax({
                dataType: "json",
                data: params,
                type: "POST",
                url: GPSettings.servicesAddr+"/uploadSnippet",
                success: (res) => {
                    if (res.result === "error")
                        reject();
                    else {
                        resolve(res)
                    }
                },
                error: reject
              });

        });
    },

    deleteSnippet: function(snippetId) {
        return new Promise((resolve, reject) => {
            var params = {
                id : snippetId,
                email: GPStorageFMG.onlineAppEmail,
                token: GPStorageFMG.token
            };
            $.ajax({
                dataType: "json",
                data: params,
                type: "POST",
                url: GPSettings.servicesAddr+"/deleteSnippet",
                success: (res) => {
                    if (res.result==="error")
                        reject();
                    else
                        GP.loadSnippets().then(GP.processSnippets);
                    resolve() },
                error: reject
              });

        })
    },

    ensureLogged: function(callback) {
        if (GPStorageFMG.token)
            return callback();
        
        //not logged, display login form
        let component = new GPLogin({
            target: document.body,
            props: {
                sendLogin: GPStorageFMG.sendLogin
            }
        });
        component.open().then(async (res) => {
            let res2 = await jQuery.getJSON({
                type: "GET",
                url: GPSettings.webSiteAddr + "/api/apiusertoken",
              });

            GPStorageFMG.onlineAppEmail = res2.email;
            GPStorageFMG.token = res2.token;
            if (res2.hasPremium) {
                GPSettings.products.premium_database.active = true;
                GPSettings.products.custom_background.active = true;
                GPSettings.products.four_seasons.active = true;
                GPSettings.products.vegetables_database.active = jQuery.inArray("PAO_VD",res2['userPackages'])>-1;
                GPSettings.products.extra_database.active = jQuery.inArray("PAO_EXT",res2['userPackages'])>-1;
            }
            callback();
        });
    },

    sendLogin: function (username, pass) {
        let params = {
            email: username,
            pass: pass
        };

        return jQuery.getJSON({
            type: "POST",
            data: params,
            url: GPSettings.webSiteAddr + "/fmg/login"
          });
    },

    closeApp: function() {
        window.location = "/users/profile";
    }
    
};
